// extracted by mini-css-extract-plugin
export default {"matchStatisticsWidgetContent__frame":"styles_matchStatisticsWidgetContent__frame__LUozh","matchStatisticsWidgetContent__error":"styles_matchStatisticsWidgetContent__error__vHEKi"};